// extracted by mini-css-extract-plugin
export default {"popUp":"popUp_popUp__3nok3","popUpRow":"popUp_popUpRow__673I3","side":"popUp_side__2AYT6","top":"popUp_top__Alww+","main":"popUp_main__PMesa"};